import { Global, css } from '@emotion/core';
import museoSansCondensed300 from './fonts/MuseoSansCondensed-300.woff2';
import museoSansCondensed500 from './fonts/MuseoSansCondensed-500.woff2';
import museoSansCondensed700 from './fonts/MuseoSansCondensed-700.woff2';
import desyrel from './fonts/Desyrel.ttf';
import { Css } from '../ui';

export const FONT_FAMILY_MUSEO_SANS_CONDENSED = 'Museo Sans Condensed';
export const FONT_FAMILY_DESYREL = 'Desyrel';

export const customFonts = [
	{
		family: FONT_FAMILY_MUSEO_SANS_CONDENSED,
		url: museoSansCondensed300,
		format: 'woff2',
		weight: 300,
	},
	{
		family: FONT_FAMILY_MUSEO_SANS_CONDENSED,
		url: museoSansCondensed500,
		format: 'woff2',
		weight: 500,
	},
	{
		family: FONT_FAMILY_MUSEO_SANS_CONDENSED,
		url: museoSansCondensed700,
		format: 'woff2',
		weight: 700,
	},
	{
		family: FONT_FAMILY_DESYREL,
		url: desyrel,
		format: 'truetype',
		weight: 400,
	},
];

export function Font() {
	const customFontFaceStyles = customFonts.map(
		({ family, url, format, weight }) => css`
			@font-face {
				font-family: ${family};
				src: url(${url}) format(${format});
				font-display: swap;
				${weight && `font-weight: ${weight};`}
			}
		`,
	);

	const styles = css`
		body {
			-webkit-font-smoothing: antialiased;
			top: 0 !important;
		}

		a {
			line-height: normal;
		}

		.emphasis {
			font-weight: 500;
			font-style: normal;
		}

		.overline {
			text-transform: uppercase;
			font-weight: 500;
			font-size: ${Css.pxToRem(12)};
		}
		.caption {
			font-weight: 500;
			font-size: ${Css.pxToRem(12)};
		}

		// Google Translate

		.skiptranslate {
			display: none;
		}

		#goog-gt-tt {
			display: none !important;
		}

		.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {
			display: none;
		}

		${customFontFaceStyles}
	`;

	return <Global styles={styles} />;
}
